import { render, staticRenderFns } from "./CreateGradeCategory.vue?vue&type=template&id=361124e2&scoped=true"
import script from "./CreateGradeCategory.vue?vue&type=script&lang=js"
export * from "./CreateGradeCategory.vue?vue&type=script&lang=js"
import style0 from "./CreateGradeCategory.vue?vue&type=style&index=0&id=361124e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361124e2",
  null
  
)

export default component.exports